/* @flow */
import gql from 'graphql-tag';
import type {SearchParamsType} from '../reducers/searchParams';
import {destinationCarouselFragments} from '@homeaway/react-property-carousel';
import {searchRequestQueryVariablesOverrides} from './searchRequestQuery';
import type {State as ReduxState} from '../reducers';
import transformReduxParamsToSearch from './transformReduxParamsToSearchRequest';

type AbacusState = $PropertyType<ReduxState, 'abacus'>;
type SystemState = $PropertyType<ReduxState, 'system'>;

export const destinationRecommendationsVariables = (
    params: SearchParamsType,
    abacus: AbacusState,
    system: SystemState,
    // TODO: we need to use the same variables for both searching and fetching
    // filter counts, but this is a clumsy way to tell the override function not
    // to mess with filter count pageSize, which needs to be set low so that
    // filter counts can be fetched cheaply.
    isFilteredSearchRequestCountQuery: boolean = false
) => {
    const newParams = searchRequestQueryVariablesOverrides(
        params,
        abacus,
        system,
        isFilteredSearchRequestCountQuery
    );
    return {
        filterCounts: system.searchFilterCounts,
        request: transformReduxParamsToSearch(newParams)
    };
};
const querySelectionSetId = gql`
    fragment querySelectionSetId on SearchResult {
        id
    }
`;

export const destinationRecommendationsQuery = gql`
    query DestinationRequestQuery($request: SearchResultRequest!) {
        search(request: $request) {
            destinationRecommendationResponse(
                size: 8
                target: SERP_DISCOVER_MORE_DESTINATION
            ) {
                ...DestinationCarouselRecommendedDestinationResponse
            }
            ...querySelectionSetId
        }
    }

    ${destinationCarouselFragments.RecommendedDestinationResponse}
    ${querySelectionSetId}
`;
